<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.ijaName" style="width: 140px;" size="small " placeholder="请输入应聘者名称"
                        clearable></el-input>
                    <el-select v-model="formDatas.ijabProgress" size="small " clearable placeholder="是否完成背调"
                        @change="partserch">
                        <el-option label="是" value="是" key="2"></el-option>
                        <el-option label="否" value="否" key="1"></el-option>
                    </el-select>
                    <el-select v-model="formDatas.ijabEducation" size="small" clearable placeholder="学历是否匹配"
                        @change="partserch">
                        <el-option label="匹配" value="匹配" key="2"></el-option>
                        <el-option label="不匹配" value="不匹配" key="1"></el-option>
                        <el-option label="查不到" value="查不到" key="3"></el-option>
                    </el-select>
                    <el-select v-model="formDatas.ijabSocial" size="small" clearable placeholder="社保是否匹配"
                        @change="partserch">
                        <el-option label="匹配" value="匹配" key="2"></el-option>
                        <el-option label="不匹配" value="不匹配" key="1"></el-option>
                    </el-select>
                    <el-select v-model="formDatas.ijabBelongUserId" placeholder="请选择背调员" size="small"
                        style="width: 140px" clearable v-if="postid == 2">
                        <el-option v-for="(item, index) in getIvUserList_data || []" :label="item.iuName"
                            :value="item.iuId" :key="item.iuId"
                            :style="{ color: item.dmDelete == 2 ? 'red' : '' }"></el-option>
                    </el-select>
                    <!-- <el-select size="small" v-model="formDatas.dmDelete" clearable @change="partserch" placeholder="请选择"
                        v-if="post == 2" style="width: 130px">
                        <el-option label="已删除" :value="2" key="2"></el-option>
                        <el-option label="未删除" :value="1" key="1"></el-option>
                    </el-select> -->
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <el-button v-if="postid == 2" type="primary" size="small" style="margin-left: 10px"
                        @click="IuUpdata">修改背调员</el-button>
                    <!-- <el-button type="primary" size="small" style="margin-left: 10px;"
                        @click="businessOpportunitiesClicks()">转商机申请</el-button> -->
                    <!-- <el-button type="primary" size="small" style="margin-left: 10px;"
                        @click="claimClicks(4)">批量审核</el-button> -->
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="success" size="small" style="margin-right: 20px" @click="BoxOpen"
                      >新建招聘渠道</el-button> -->

                    <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button>
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="ijabId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-dialog :title="edit ? '编辑背调信息' : '新增背调信息'" :close-on-click-modal="false" :visible.sync="dialog"
                width="70%" top="8vh">
                <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:65vh">
                    <div
                        style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                        <el-form-item label="是否完成背调" prop="ijabProgress">
                            <el-select v-model="form.ijabProgress" clearable placeholder="请选择" style="width: 50%;">
                                <el-option label="是" value="是" key="2"></el-option>
                                <el-option label="否" value="否" key="1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="未完成背调描述" prop="ijabProgressDes" v-if="form.ijabProgress == '否'">
                            <el-select v-model="form.ijabProgressDes" clearable placeholder="请选择" style="width: 50%;">
                                <el-option label="应届生，无专职工作经验" value="应届生，无专职工作经验" key="2"></el-option>
                                <el-option label="对方提供公司查不到" value="对方提供公司查不到" key="1"></el-option>
                                <el-option label="用户已离职" value="用户已离职" key="3"></el-option>
                                <el-option label="用户未入职" value="用户未入职" key="4"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="学历是否匹配" prop="ijabEducation">
                            <el-select v-model="form.ijabEducation" clearable placeholder="请选择" style="width: 50%;">
                                <el-option label="匹配" value="匹配" key="2"></el-option>
                                <el-option label="不匹配" value="不匹配" key="1"></el-option>
                                <el-option label="查不到" value="查不到" key="3"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="学历不匹配描述" prop="ijabEducationDes" v-if="form.ijabEducation == '不匹配'">
                            <el-input v-model="form.ijabEducationDes" type="textarea" :row="2" style="width: 50%;"
                                placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="社保是否匹配" prop="ijabSocial">
                            <el-select v-model="form.ijabSocial" clearable placeholder="请选择" style="width: 50%;">
                                <el-option label="匹配" value="匹配" key="2"></el-option>
                                <el-option label="不匹配" value="不匹配" key="1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="背调公司名" prop="ijabCompany">
                            <el-input v-model="form.ijabCompany" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="配合背调的联系人" prop="ijabContactUser">
                            <el-input v-model="form.ijabContactUser" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="配合背调的联系人的岗位" prop="ijabContactPost">
                            <el-input v-model="form.ijabContactPost" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="上级领导姓名" prop="ijabUpName">
                            <el-input v-model="form.ijabUpName" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="上级领导任职岗位" prop="ijabUpPost">
                            <el-input v-model="form.ijabUpPost" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="联系电话" prop="ijabContactPhone">
                            <div v-for="(item, index) in ijabContactPhone_arr" :key="index" style="margin: 20px 0;">
                                <el-button type="danger" icon="el-icon-remove" @click="phoneDel(index)"></el-button>
                                <el-input v-model="item.value" style="width: 50%;margin: 0 30px;"
                                    placeholder="请输入"></el-input>
                                <el-button type="success" icon="el-icon-circle-plus" @click="phoneAdd"></el-button>
                            </div>

                        </el-form-item>
                        <el-form-item label="不吻合记录" prop="ijabMismatchedDes">
                            <el-card style="width: 90%;margin: 20px auto;">
                                <div style="margin: 5px 0;display: flex;align-items: center;height: 60px;">
                                    <div style="font-size: 14px;margin: 30px;width: 100px;">时间:</div>
                                    <el-input v-model="ijabMismatchedDesObj.ijabmTime" type="textarea" :row="2"
                                        style="width: 50%;" placeholder="请输入"></el-input>
                                </div>
                                <div style="margin: 5px 0;display: flex;align-items: center;height: 60px;">
                                    <div style="font-size: 14px;margin: 30px;width: 100px;">岗位:</div>
                                    <el-input v-model="ijabMismatchedDesObj.ijabmPost" type="textarea" :row="2"
                                        style="width: 50%;" placeholder="请输入"></el-input>
                                </div>
                                <div style="margin: 5px 0;display: flex;align-items: center;height: 60px;">
                                    <div style="font-size: 14px;margin: 30px;width: 100px;">工作内容:</div>
                                    <el-input v-model="ijabMismatchedDesObj.ijabmWorker" type="textarea" :row="2"
                                        style="width: 50%;" placeholder="请输入"></el-input>
                                </div>
                                <div style="margin: 5px 0;display: flex;align-items: center;height: 60px;">
                                    <div style="font-size: 14px;margin: 30px;width: 100px;">离职原因:</div>
                                    <el-input v-model="ijabMismatchedDesObj.ijabmLever" type="textarea" :row="2"
                                        style="width: 50%;" placeholder="请输入"></el-input>
                                </div>
                                <div style="margin: 5px 0;display: flex;align-items: center;height: 60px;">
                                    <div style="font-size: 14px;margin: 30px;width: 100px;">工作能力:</div>
                                    <el-input v-model="ijabMismatchedDesObj.ijabmAbility" type="textarea" :row="2"
                                        style="width: 50%;" placeholder="请输入"></el-input>
                                </div>
                                <div style="margin: 5px 0;display: flex;align-items: center;height: 60px;">
                                    <div style="font-size: 14px;margin: 30px;width: 100px;">其他:</div>
                                    <el-input v-model="ijabMismatchedDesObj.ijabmOther" type="textarea" :row="2"
                                        style="width: 50%;" placeholder="请输入"></el-input>
                                </div>
                            </el-card>
                        </el-form-item>
                    </div>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleClose">取 消</el-button>
                    <el-button type="primary" @click="SureBtn">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 修改面试官 -->
            <el-dialog title="修改背调员" :close-on-click-modal="false" :visible.sync="IsIuShow" width="40%" top="8vh">
                <div style="padding: 20px;">
                    <el-select v-model="iuIds" placeholder="请选择背调员" size="small" style="width: 140px" clearable>
                        <el-option v-for="(item, index) in getIvUserList_data || []" :label="item.iuName"
                            :value="item.iuId" :key="item.iuId"
                            :style="{ color: item.dmDelete == 2 ? 'red' : '' }"></el-option>
                    </el-select>
                </div>

                <span slot="footer" class="dialog-footer">
                    <el-button @click="IuhandleClose">取 消</el-button>
                    <el-button type="primary" @click="IuSureBtn">确 定</el-button>
                </span>
            </el-dialog>
        </div>

    </div>
</template>

<script>

import {
    addIvJobChannel, deleteIvJobChannel, getIvJobApplicantBackgroundList, updateIvJobApplicantBackground, getIvUserList,
    getNcUserList, updateIvJobApplicantBackgroundBelongUser

} from "../../api/api";
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
var FileSaver = require('file-saver');
let Base64 = require("js-base64").Base64;
export default {
    name: "",
    components: {},
    data() {
        return {
            IsIuShow: false,
            getIvUserList_data: [],
            ijabMismatchedDesObj: {
                ijabmTime: '',
                ijabmPost: '',
                ijabmWorker: '',
                ijabmLever: '',
                ijabmAbility: '',
                ijabmOther: '',
            },
            ijabContactPhone_arr: [{ value: '', id: 0, }],
            postForm: {

            },
            userarr: [],
            level_Four: [],
            level_Three: [],
            key: 'ijabId',
            dialog: false,
            edit: false,
            form: {
                ijcName: '',
                ijcOrder: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "ijaName",
                    key: "ijaName",
                    fixed: 'left',
                    title: "应聘者",
                    width: 100,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "ijabProgress",
                    key: "ijabProgress",
                    fixed: 'left',
                    title: "完成背调",
                    width: 80,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span style={{ color: row.ijabProgress == '否' ? 'red' : 'black' }} >
                                {row.ijabProgress}
                            </span>
                        )
                    }
                },
                {
                    field: "ijabProgressDes",
                    key: "ijabProgressDes",
                    title: "未完成描述",
                    width: 150,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "ijabEducation",
                    key: "ijabEducation",
                    title: "学历匹配",
                    width: 100,
                    align: "center",
                    // edit: true,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span style={{ color: row.ijabEducation == '不匹配' ? 'red' : 'black' }} >
                                {row.ijabEducation}
                            </span>
                        )
                    }
                },
                {
                    field: "ijabEducationDes",
                    key: "ijabEducationDes",
                    title: "学历不匹配描述",
                    width: 150,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "ijabSocial",
                    key: "ijabSocial",
                    title: "社保匹配",
                    width: 100,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span style={{ color: row.ijabSocial == '不匹配' ? 'red' : 'black' }} >
                                {row.ijabSocial}
                            </span>
                        )
                    }
                    // edit: true,
                },
                {
                    field: "ijabCompany",
                    key: "ijabCompany",
                    title: "背调公司名",
                    width: 140,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "ijabContactUser",
                    key: "ijabContactUser",
                    title: "配合背调的联系人",
                    width: 120,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "ijabContactPost",
                    key: "ijabContactPost",
                    title: "配合背调的联系人的岗位",
                    width: 170,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "ijabUpName",
                    key: "ijabUpName",
                    title: "上级领导姓名",
                    width: 100,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "ijabUpPost",
                    key: "ijabUpPost",
                    title: "上级领导任职岗位",
                    width: 120,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "ijabContactPhone",
                    key: "ijabContactPhone",
                    title: "联系电话",
                    width: 200,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div>
                                {
                                    row.ijabContactPhone && JSON.parse(row.ijabContactPhone).length > 0 ?
                                        JSON.parse(row.ijabContactPhone).map(item => {
                                            const str = <div>{item.value}</div>
                                            return str
                                        }) : ''
                                }
                            </div>
                        );
                    },
                    // edit: true,
                },
                {
                    field: "ijabMismatchedDes",
                    key: "ijabMismatchedDes",
                    title: "不吻合记录",
                    width: 520,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div>
                                {
                                    row.ijabMismatchedDes ?
                                        <div>
                                            {
                                                JSON.parse(row.ijabMismatchedDes).ijabmTime ? <div style="margin:10px">
                                                    <span>时间</span>:  <span>{JSON.parse(row.ijabMismatchedDes).ijabmTime} </span>
                                                </div> : ''
                                            }
                                            {
                                                JSON.parse(row.ijabMismatchedDes).ijabmPost ? <div style="margin:10px">
                                                    <span>岗位</span>:  <span>{JSON.parse(row.ijabMismatchedDes).ijabmPost} </span>
                                                </div> : ''
                                            }
                                            {
                                                JSON.parse(row.ijabMismatchedDes).ijabmWorker ? <div style="margin:10px">
                                                    <span>工作内容</span>:  <span>{JSON.parse(row.ijabMismatchedDes).ijabmWorker} </span>
                                                </div> : ''
                                            }
                                            {
                                                JSON.parse(row.ijabMismatchedDes).ijabmLever ? <div style="margin:10px">
                                                    <span>离职原因</span>:  <span>{JSON.parse(row.ijabMismatchedDes).ijabmLever} </span>
                                                </div> : ''
                                            }
                                            {
                                                JSON.parse(row.ijabMismatchedDes).ijabmAbility ? <div style="margin:10px">
                                                    <span>工作能力</span>:  <span>{JSON.parse(row.ijabMismatchedDes).ijabmAbility} </span>
                                                </div> : ''
                                            }
                                            {
                                                JSON.parse(row.ijabMismatchedDes).ijabmOther ? <div style="margin:10px">
                                                    <span>其他</span>:  <span>{JSON.parse(row.ijabMismatchedDes).ijabmOther} </span>
                                                </div> : ''
                                            }


                                        </div>

                                        : ''
                                }
                            </div>
                        );
                    },
                    // edit: true,
                },
                {
                    field: "iuName",
                    key: "iuName",
                    title: "面试官",
                    width: 80,
                    align: "center",
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "ijabBelongUserName",
                    key: "ijabBelongUserName",
                    title: "背调员",
                    width: 80,
                    fixed: "right",
                    align: "center",
                },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 200,
                    fixed: 'right',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: green"
                                        on-click={() => this.handleEdit(row)}
                                    >
                                        编辑
                                    </el-button>
                                }
                                {row.ijaBiographicalNotes ? (
                                    <el-button
                                        size="mini"
                                        type="text"
                                        on-click={() => this.Download(row)}
                                    >
                                        下载简历
                                    </el-button>
                                ) : (
                                    ""
                                )}
                                {row.ijaBiographicalNotes ? (
                                    <el-button
                                        size="mini"
                                        type="text"
                                        on-click={() =>
                                            window.open(
                                                `https://filepreview.aojuai.com/onlinePreview?url=${encodeURIComponent(
                                                    Base64.encode(row.ijaBiographicalNotes)
                                                )}`
                                            )
                                        }
                                    >
                                        预览简历
                                    </el-button>
                                ) : (
                                    ""
                                )}
                                {row.ijaFileRegisterForm ? (
                                    <el-button
                                        size="mini"
                                        type="text"
                                        on-click={() => this.Download2(row)}
                                    >
                                        下载面试登记表
                                    </el-button>
                                ) : (
                                    ""
                                )}
                                {row.ijaFileRegisterForm ? (
                                    <el-button
                                        size="mini"
                                        type="text"
                                        on-click={() =>
                                            window.open(
                                                `https://filepreview.aojuai.com/onlinePreview?url=${encodeURIComponent(
                                                    Base64.encode(row.ijaFileRegisterForm)
                                                )}`
                                            )
                                        }
                                    >
                                        预览面试登记表
                                    </el-button>
                                ) : (
                                    ""
                                )}
                                {/* {
                                 
                                        <el-button
                                            size="mini"
                                            type="text"
                                            style="color: red"
                                            on-click={() => this.handleDelete(row)}
                                        >
                                            删除
                                        </el-button> 
                                } */}
                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                naLevel: 1,
                currentPage: 1,
                pageSize: 10,
            },
            iuIds: '',
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.postid = localStorage.getItem("iuPost");
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
        getIvUserList({ iuPost: 5 }).then(res => {
            this.getIvUserList_data = res.data
        })
        this.getPost('industry')
    },
    mounted() { },
    methods: {
        Out() {
            const bulkdata = {
                ...this.formDatas
            }
            this.openLoading();
            var s = qs.stringify(bulkdata);
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/iv-job-applicant-background/exportIvJobApplicantBackground',
                data: s,
                withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'userid': window.localStorage.getItem('iuId')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '背调列表.xlsx');
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },

        IuSureBtn() {
            console.log(this.selectedRowKeysCollection.toString())
            const s = {
                ijabIds: this.selectedRowKeysCollection.toString(),
                ijabBelongUserId: this.iuIds,
            };
            updateIvJobApplicantBackgroundBelongUser(s).then((res) => {
                this.IuhandleClose();
                this.getList();
            });
        },
        IuhandleClose() {
            this.iuIds = "";
            this.IsIuShow = false;
            this.checkboxOption.selectedRowKeys = [];
            this.selectedRowKeysCollection = [];
        },
        IuUpdata() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: "danger",
                });
            } else {
                this.IsIuShow = true;
            }
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Download(row) {
            this.openLoading()
            const suffix = row.ijaName + '.' + row.ijaBiographicalNotes.substring(row.ijaBiographicalNotes.lastIndexOf('.') + 1)
            FileSaver.saveAs(row.ijaBiographicalNotes, suffix)
            this.loadings.close()
        },
        Download2(row) {
            this.openLoading()
            const suffix = row.ijaName + '.' + row.ijaFileRegisterForm.substring(row.ijaFileRegisterForm.lastIndexOf('.') + 1)
            FileSaver.saveAs(row.ijaFileRegisterForm, suffix)
            this.loadings.close()
        },
        phoneDel(index) {
            if (this.ijabContactPhone_arr.length == 1) {
                return
            }
            this.ijabContactPhone_arr.splice(index, 1)
        },
        phoneAdd() {
            const s = { value: '' };
            this.ijabContactPhone_arr.push(s)
        },
        getPost(key) {
            const userpost = JSON.parse(sessionStorage.getItem('userPost')) || [];
            userpost.forEach((item, index) => {
                if (item.nsaMenuKey == key) {
                    this.postForm[item.nsaFuncKey] = item.nsaFuncLabel
                }
            })
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteIvJobChannel({ ijabId: row.ijabId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.ijabMismatchedDesObj = data.ijabMismatchedDes ? JSON.parse(data.ijabMismatchedDes) : {
                ijabmTime: '',
                ijabmPost: '',
                ijabmWorker: '',
                ijabmLever: '',
                ijabmAbility: '',
                ijabmOther: '',
            };
            this.ijabContactPhone_arr = data.ijabContactPhone ? JSON.parse(data.ijabContactPhone) : [{ value: '', id: 0, }];
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addIvJobChannel(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const newForm = JSON.parse(JSON.stringify(this.form))
                        newForm.ijabContactPhone = this.ijabContactPhone_arr.length > 0 ? JSON.stringify(this.ijabContactPhone_arr) : '';
                        newForm.ijabMismatchedDes = JSON.stringify(this.ijabMismatchedDesObj)
                        updateIvJobApplicantBackground(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.ijabMismatchedDesObj = {
                ijabmTime: '',
                ijabmPost: '',
                ijabmWorker: '',
                ijabmLever: '',
                ijabmAbility: '',
                ijabmOther: '',
            }
            this.ijabContactPhone_arr = [{ value: '', id: 0, }]
            this.$refs['formRef'].resetFields();
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.ijabId = row.ijabId
                    //console.log(jsonObj);
                    updateIvJobApplicantBackground(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                //console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // //console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        //console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {
            this.checkboxOption.selectedRowKeys = selectedRowKeys;
            if (isSelected) {
                this.selectedRowKeysCollection = [...new Set(this.selectedRowKeysCollection.concat(selectedRowKeys))] || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key] * 1) > -1) {
                        console.log(item);
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key] * 1), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                //console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            //console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getIvJobApplicantBackgroundList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getIvJobApplicantBackgroundList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getIvJobApplicantBackgroundList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>